import { API_URL } from "src/utils/config";

export async function downloadReportCSV(from: number, to: number, shipper: string, transporter: string) {
  let url = `${API_URL}report?from=${from}&to=${to}`;
  if (shipper) {
    url += `&shippingCompany=${shipper}`;
  }

  try {
    const token = window.localStorage.getItem("token");
    const response = await fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/csv',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const csv = await response.text();
    return csv;
  } catch (error) {
    console.error('There has been a problem with your fetch operation: ', error);
    throw error;
  }
}
